export const CONSTANTS = {
  gclientid:
    "717494304680-j0aoq22eoemtc2mtkkkdrin76cgea1k5.apps.googleusercontent.com",
};

export const GOOGLE_MAPS_API_KEY = "AIzaSyCFSLyU27_QSIaMcHXZb68GQpwYdd5rKgc"